export const playerErrorStates = {
  0: { message: 'A/V format not supported', code: 4032 },
  1: { message: 'Cannot connect to server or connection lost', code: 1001 },
  2: { message: 'Unidentified error', code: 3016 },
  3: { message: 'Insufficient resources', code: 3016 },
  4: { message: 'Content corrupt or invalid', code: 4032 },
  5: { message: 'Content not available', code: 1001 },
  6: { message: 'Content not available at given position', code: 3016 },
  7: { message: 'Content blocked due to parental control', code: 3016 },
};

export const drmErrorStates = {
  0: { message: 'No license, consumption of the content is blocked', code: 6001 },
  1: { message: 'Invalid license, consumption of the content is blocked', code: 6004 },
  2: { message: 'Valid license, consumption of the content is unblocked', code: 0 },
};

export const playerStates = {
  STOPPED: 0,
  PLAYING: 1,
  PAUSED: 2,
  CONNECTING: 3,
  BUFFERING: 4,
  FINISHED: 5,
  ERROR: 6,
};
